import materaLakeside8_1 from "./1.png";
import materaLakeside8_2 from "./2.png";

const materaLakeside8 = [materaLakeside8_1, materaLakeside8_2];

export default materaLakeside8;
